const normalizeSearchText = (value) => (
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/<[^>]*>/g, ' ')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
);

const getAttributes = (answer) => answer?.attributes || {};

const tokenScore = (field, terms, value) => {
  if (!field || terms.length === 0) return 0;

  const matches = terms.filter((term) => field.includes(term)).length;
  const allTermsMatch = matches === terms.length;

  return (matches * value) + (allTermsMatch ? value : 0);
};

const fieldScore = ({
  field,
  query,
  terms,
  exact,
  startsWith,
  contains,
  tokenValue
}) => {
  if (!field) return 0;

  let score = tokenScore(field, terms, tokenValue);

  if (field === query) {
    score += exact;
  } else if (field.startsWith(query)) {
    score += startsWith;
  }

  const index = field.indexOf(query);
  if (index >= 0) {
    score += contains;
    score += Math.max(0, 100 - index);
    score += Math.max(0, 60 - Math.abs(field.length - query.length));
  }

  return score;
};

export const quickAnswerSearchScore = (answer, searchTerm) => {
  const query = normalizeSearchText(searchTerm);
  if (!query) return 0;

  const terms = query.split(' ').filter(Boolean);
  const attributes = getAttributes(answer);
  const title = normalizeSearchText(attributes.title);
  const answerText = normalizeSearchText(attributes.answer);

  return fieldScore({
    field: title,
    query,
    terms,
    exact: 10000,
    startsWith: 8000,
    contains: 6000,
    tokenValue: 120
  }) + fieldScore({
    field: answerText,
    query,
    terms,
    exact: 5000,
    startsWith: 4000,
    contains: 3000,
    tokenValue: 50
  });
};

export const sortQuickAnswersBySearch = (answers, searchTerm) => {
  if (!Array.isArray(answers)) return [];
  if (!normalizeSearchText(searchTerm)) return answers;

  return answers
    .map((answer, index) => ({
      answer,
      index,
      score: quickAnswerSearchScore(answer, searchTerm)
    }))
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return a.index - b.index;
    })
    .map(({ answer }) => answer);
};

export const rankQuickAnswersResponse = (data, searchTerm, displayLimit) => {
  const rankedData = {
    ...data,
    templates: {
      ...data?.templates,
      data: sortQuickAnswersBySearch(data?.templates?.data, searchTerm)
    }
  };

  if (displayLimit) {
    rankedData.templates.data = rankedData.templates.data.slice(0, displayLimit);
  }

  return rankedData;
};
